import React, {FC} from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {
  BusinessSchedule as BusinessScheduleProto,
  Recurrence as RecurrenceProto,
} from '@wix/ambassador-table-reservations-v1-experience/types'
import {utcToZonedTime} from '@wix/table-reservations-lib/timezone'

import {getShortDate} from '../../utils/dateString'

interface Props {
  className?: string
  businessSchedule?: BusinessScheduleProto
  regionalSettings?: string
  timeZone?: string | null
}

export const ExperienceSchedule: FC<Props> = ({
  className,
  businessSchedule,
  regionalSettings,
  timeZone,
}) => {
  const {t} = useTranslation()

  if (businessSchedule) {
    const multipleBusinessScheduleEntries =
      businessSchedule?.entries && businessSchedule.entries.length > 1
    const businessScheduleEntry = businessSchedule?.entries?.[0]
    const weeklyRecurrence = businessScheduleEntry?.recurrence === RecurrenceProto.WEEKLY

    if (multipleBusinessScheduleEntries || weeklyRecurrence) {
      return (
        <Text className={className}>
          {t('uou-reservations.experiences.schedule.multiple-dates')}
        </Text>
      )
    }

    const oneTimeOptions = businessScheduleEntry?.oneTimeOptions

    return (
      <Text className={className}>
        {getShortDate(
          utcToZonedTime(
            new Date(`${oneTimeOptions?.startDate}T${oneTimeOptions?.startTime}`),
            timeZone,
          ),
          regionalSettings,
        )}
      </Text>
    )
  }

  return (
    <Text className={className}>
      {t('uou-reservations.experiences.schedule.date-and-time-tbd')}
    </Text>
  )
}
